import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { SidebarComponent } from './components/layout/sidebar/sidebar.component';
import { PendingTaskDueSoonChipComponent } from './components/domain/collection-pending-tasks/pending-task-due-soon-chip/pending-task-due-soon-chip.component';
import { AppUpdateNoticeComponent } from './components/core/app-update-notice/app-update-notice.component';
import { UpcomingMeetingNoticeComponent } from './components/core/upcoming-meeting-notice/upcoming-meeting-notice.component';
import { SessionService } from './auth/session.service';
import { LanguageService } from './services/infrastructure/language/language.service';
import { AppUpdateService } from './services/infrastructure/app-update/app-update.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [
    IonApp,
    IonRouterOutlet,
    SidebarComponent,
    PendingTaskDueSoonChipComponent,
    AppUpdateNoticeComponent,
    UpcomingMeetingNoticeComponent,
  ],
})
export class AppComponent implements OnInit {
  private readonly sessionService = inject(SessionService);
  private readonly languageService = inject(LanguageService);
  private readonly appUpdateService = inject(AppUpdateService);
  private readonly router = inject(Router);

  constructor() {}

  /**
   * Inicializa la renovación automática de sesión, el idioma y el aviso de
   * versión nueva al arrancar la app
   */
  ngOnInit(): void {
    this.sessionService.initialize();
    this.languageService.initLanguage();
    this.appUpdateService.init();
  }

  /**
   * Lleva a la vista personal de Pendientes filtrada por `urgent`, que es
   * exactamente el conjunto que hizo aparecer el chip —vencidos o a menos de una
   * hora—, para que la lista muestre lo mismo que el chip contó.
   */
  goToDueSoonPendingTasks(): void {
    this.router.navigate(['/collections/pending-tasks'], {
      queryParams: { scope: 'personal', filter: 'urgent' },
    });
  }
}
